import axios from 'axios'
import { Buffer } from 'buffer'
import { getAccessToken, getRefreshToken, setAccessToken, logout } from '../common'

axios.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken()
    if (accessToken) {
      config.headers['x-auth-token'] = 'Bearer ' + accessToken
    }
    return config
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    const refreshToken = getRefreshToken()

    if (refreshToken && error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      const auth = Buffer
        .from(`${window._env_.REACT_APP_API_USER}:${window._env_.REACT_APP_API_PASSWORD}`)
        .toString('base64')

      try {
        const res = await axios.post(
          `${window._env_.REACT_APP_API_URL}/auth/refreshtoken`,
          { refreshToken },
          { headers: { Authorization: 'Basic ' + auth } }
        )

        if (res.status === 200) {
          setAccessToken(res.data.accessToken)
          return axios(originalRequest)
        }
      } catch {
        logout()
      }
    }

    return Promise.reject(error)
  }
)

export default axios
